module.exports = __webpack_public_path__ + "static/img/ios1.1.016634f6.jpg";